import { getPathAPI, getAuthHeaders, triggerBlobDownload } from "@/helpers";
import axios, { AxiosResponse } from "axios";
import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

class AdjusterfileService extends BaseCollectionService {
  constructor() {
    super("agent-reports");
  }
  public async exportAgentReportFile(payload: any): Promise<AxiosResponse> {
    const path = `/agent-report/file/view`;
    const response = await axios({
      url: `${getPathAPI()}${path}`,
      method: "GET",
      responseType: "blob",
      params: {
        agentCode: payload.agentCode,
        fileName: payload.fileName
      },
      headers: getAuthHeaders()
    });
    triggerBlobDownload(response.data, `${payload.fileName}`);
    return response;
  }

  async getUploadedAgentReports(): Promise<ResponseWrapper> {
    const path = `agent-reports/uploaded`;
    return await this.request(
      {
        method: "get",
        url: path
      },
      { useToken: "access" }
    );
  }
}

export default new AdjusterfileService();
